import { SideMenu } from './sidemenu/sidemenu';

export { SideMenu };
